import { LeverageButton } from "./LeverageButton";

export const ApproveAsset = (props) => (
  <>
    <LeverageButton {...props} />
  </>
);
